import {
  Component,
  OnInit,
  HostListener,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

function urltoFile(url, filename, mimeType) {
  return fetch(url)
    .then(res => {
      return res.arrayBuffer();
    })
    .then(buf => {
      return new File([buf], filename, { type: mimeType });
    });
}

function base64MimeType(encoded) {
  let result = null;

  if (typeof encoded !== 'string') {
    return result;
  }

  const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

  if (mime && mime.length) {
    result = mime[1];
  }

  return result;
}

@Component({
  selector: 'ng-media-crop-view',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperViewComponent implements OnInit {
  public buttons = [];

  @Input() public imageEvent: any = '';
  @Input() public cropPreview = false;
  @Output() public imageCropped: EventEmitter<any> = new EventEmitter<any>();
  croppedImage: any = '';

  fileChangeEvent(event: any): void {
    this.imageEvent = event;
  }

  public ngMediaEventChange(event) {}

  public fileUploadFinish(event) {}

  async onCrop(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

    const mime = base64MimeType(event.base64);
    const file = await urltoFile(event.base64, 'image', mime);
    this.imageCropped.emit({ ...event, file });
  }

  ngOnInit() {}
}
